import { createReducer } from '@reduxjs/toolkit';
import { initialPrintState as initialState } from './state';
import * as actions from './action';
import { setNestedField } from '../utils';

export default createReducer(initialState(), (builder) => {
  builder
    .addCase(actions.setPrint, (state, { payload: { field, value } }) => {
      setNestedField(state, field, value);
    })
    .addCase(actions.resetPrint, (state) => {
      return initialState();
    });
});
